/**
 *
 */
export enum CountryID {
  Netherland = 166,
  Belgium = 20,
  Other = -9999,
}
